import { render, staticRenderFns } from "./brainFoot.vue?vue&type=template&id=43ccf4ee&scoped=true&"
import script from "./brainFoot.vue?vue&type=script&lang=js&"
export * from "./brainFoot.vue?vue&type=script&lang=js&"
import style0 from "./brainFoot.vue?vue&type=style&index=0&id=43ccf4ee&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43ccf4ee",
  null
  
)

export default component.exports